export default __webpack_public_path__ + "static/media/hello-hive-logo.24d261c5.png";